import Controller from '../abstracts/Controller';
import 'scss-templates/t-editorial-page.scss';

export default class EditorialPageController extends Controller {
  static get COMPONENTS() {
    return [
      'ArticleLoaderComponent',
      'ArticleHeroComponent',
      'ArticleHeroScrollComponent',
      'ArticleTwinScrollComponent',
      'ArticleTripleLaunchComponent',
      'ArticleGalleryComponent',
      'ArticleProductComponent',
      'ArticleProductVariantComponent',
      'ArticleLaunchScrollComponent',
      'AddToWishlistComponent',
      'WishlistComponent'
    ];
  }
}
